import { Box, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { APP_ICONS } from "../../assets";
import DynamicTable from "../../components/dynamicTable";
import Loader from "../../components/loader";
import TextInput from "../../components/textInput";
import { getVendorOrders } from "../../services/Vendor";
import AppContainer from "./../../components/containers/AppContainer";

const tableHeader = [
  "Order#ID",
  "User Data",
  "Address",
  "Tax Amount",
  "Amount",
  "Order Date",
  "Delivery Date",
  // "Referral Commission",
  "STATUS",
];

const displayRows = [
  "orderId",
  "order_user_data",
  "delivered_address",
  "tax_amount",
  "order_amount",
  "created_at",
  "delivery_date",
  // "referral_commission",
  "order_status",
];

const VendorCompletedOrders = ({ data }) => {
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allOrders, setAllOrders] = useState([]);

  useEffect(() => {
    fetchUserOrder();
  }, [data]);

  console.log(data?.vendorDetails, "data?.vendorDetails");

  const fetchUserOrder = async () => {
    try {
      setIsLoading(true);
      const response = await getVendorOrders(data?.vendorDetails?._id);
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        let data = response?.data?.data;

        setAllOrders(data);
        setFilteredData(data);
      } else {
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching orders:", error);
    }
  };
  useEffect(() => {
    const filtered = allOrders?.filter(
      (row) =>
        row?.orderId?.toLowerCase()?.includes(filterText?.toLowerCase()) ||
        row?.city?.toLowerCase()?.includes(filterText?.toLowerCase()) ||
        row?.city?.toLowerCase()?.includes(filterText?.toLowerCase())
    );

    setFilteredData(filtered);
  }, [filterText]);

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  return (
    <AppContainer>
      <Stack
        px={2.5}
        py={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack>
          <Typography variant="h5" fontWeight={600}>
            Delivered Orders
          </Typography>
        </Stack>
      </Stack>
      <Divider sx={{ borderColor: "#BDBDBD" }} />
      <Stack px={2.5} py={2} direction={"row"} alignItems={"center"}>
        <Box>
          <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search By details"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={filterText}
            onChange={handleFilterChange}
          />
        </Box>
      </Stack>
      <Divider />
      {filteredData?.length > 0 ? (
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={filteredData}
          showPagination={true}
          showRequestMenu={true}
        />
      ) : (
        <Typography
          color="black"
          fontSize={14}
          fontWeight={700}
          textAlign="center"
          padding="30px 0"
        >
          No Completed Orders Found!
        </Typography>
      )}
      <Loader isloading={isLoading} />
    </AppContainer>
  );
};

export default VendorCompletedOrders;
